
    import './styles.scoped.css';
    export default {
  "header-cell": "awsui_header-cell_uzgsh_2i1hd_5",
  "no-divider": "awsui_no-divider_uzgsh_2i1hd_9",
  "disable-paddings": "awsui_disable-paddings_uzgsh_2i1hd_23",
  "header-cell-content": "awsui_header-cell-content_uzgsh_2i1hd_28",
  "is-visual-refresh": "awsui_is-visual-refresh_uzgsh_2i1hd_40",
  "header-cell-grid": "awsui_header-cell-grid_uzgsh_2i1hd_44"
};
  